/* eslint-disable func-names, no-console */
import 'flickity';


(function ($) {
  const $carousel = $('#hero-slider');

  $carousel.on('change.flickity', (event, index) => {
    console.log('Showing', index);
    $('.slider-info').removeClass('active');
    $(`.slider-info[data-index="${index}"]`).addClass('active');
  });

  function filterObras(btn) {
    const filter = btn.data('filter');
    $('.project-filter__filter').removeClass('active');
    btn.addClass('active');
    if (filter !== '*') {
      $('.project-cell').removeClass('show');
      $(`.project-cell.${filter}`).addClass('show');
      window.location.hash = `#${filter}`;
    } else {
      $('.project-cell').addClass('show');
      window.location.hash = '';
    }
  }

  /* Load filters from page Obras */
  if ($('.project-filter').length >= 0) {
    if (window.location.hash.substr(1) !== '') {
      const filter = window.location.hash.substr(1);
      const trigger = $(`.js-project-filter[data-filter="${filter}"]`);
      filterObras(trigger);
      $('.projects-grid').css('opacity', 1);
    } else {
      $('.js-project-filter[data-filter="*"]').addClass('active');
      $('.projects-grid').css('opacity', 1);
    }
  }

  $('.js-project-filter').on('click', function () {
    filterObras($(this));
  });

  $('.js-search-sgc-files').on('keyup', function () {
    const searchTerm = $(this).val();
    const results = [];
    if (searchTerm != '') {
      const $fileList = $('.tab-content .sgc-file');
      $fileList.each(function (index, $ele) {
        const filename = $(this)
          .text()
          .trim();
        if (filename.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
          results.push($(this).clone());
        }
      });
    }
    $('.js-search-sgc-files-result')
      .empty()
      .append(results);
  });

  if ($('body').hasClass('page-sgc-documentos')) {
    document.addEventListener('contextmenu', (event) => event.preventDefault());
    $('#modal').modal();
  }
}(jQuery));



// WEBPACK FOOTER //
// ./assets/src/js/app.js